<template>
  <div>
    <AddBankMovement
      :isOpen.sync="isAddBankMovementPanelOpen"
      v-bind:banks="banks"
      v-bind:selectedBank="bankForm.bank"
      @updateMovements="loadBankMovements({ bank: $v.bankForm.bank.$model })" />

    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <!-- <div class="title primary--text">{{ section }}</div> -->
      <v-spacer />
      <div class="d-flex justify-end align-center">
        <!-- <div>
          <v-text-field
            v-model="search"
            class="mr-3"
            append-icon="mdi-magnify"
            :label="$t('expenses.registerMovements.inputSearchLabel')"
            solo
            rounded
            hide-details
            flat
            dense/>
        </div> -->
        <div class="mx-3" v-if="movementsPermissions['create-movement']">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                color="primary"
                fab
                x-small
                depressed
                @click="addMovement"
              >
                <v-icon
                  small
                  color="white"
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('expenses.registerMovements.movements.buttonCreate') }}</span>
          </v-tooltip>
        </div>
      </div>
    </div>

    <v-flex xs12>
      <v-data-table
        :server-items-length="movementsTable.total"
        :loading-text="movementsTable.title"
        :loading="movementsTable.loading"
        :headers="movementsTable.headers"
        :items="movementsTable.data"
        :options="movementsTable.options"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50]
        }"
        @update:options="updateMovementsTable"
        class="elevation-1">
        <template v-slot:top>
          <div class="px-2">
            <v-row>
              <v-col md="3">
                <v-form ref="selectBankForm" v-model="bankForm.valid">
                  <v-select
                    rounded
                    outlined
                    dense
                    :item-text="getBankAccountText"
                    item-value="_id"
                    :items="banks.data"
                    :disabled="!banks.data.length"
                    v-model.lazy="$v.bankForm.bank.$model"
                    :label="$t('expenses.registerMovements.movements.bank')"
                    @input="$v.bankForm.bank.$touch()"
                    @blur="$v.bankForm.bank.$touch()"
                    @change="selectedMovementsDates.length == 2 && loadBankMovements({ bank: $v.bankForm.bank.$model })"
                    :error-messages="bankErrors"
                    required
                  />
                </v-form>
              </v-col>
              <v-col>
                <v-dialog
                  @keydown.esc="dateModalMovements=false"
                  ref="dialogMovementsDates"
                  v-model="dateModalMovements"
                  :return-value.sync="selectedMovementsDates"
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeTextMovements"
                      :label="$t('expenses.registerMovements.movements.movementsDateDialog.date')"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      class="calendarTextField"
                    >
                      <v-icon slot="append" color="#01D28E">
                        mdi-calendar
                      </v-icon>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="selectedMovementsDates"
                    scrollable
                    ref="picker"
                    color="primary"
                    range
                    :first-day-of-week="1"
                    :allowed-dates="allowedMovementsDates"
                    @input="orderDateRangeMovements"
                    reactive
                    no-title
                    class="pt-4"
                    :locale="locale">
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="dateModalMovements = false"
                      class="dateButton"
                    >
                      {{ $t('expenses.registerMovements.movements.movementsDateDialog.buttonBack') }}
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="confirmMovementsDates"
                      class="dateButton"
                    >
                      {{ $t('expenses.registerMovements.movements.movementsDateDialog.buttonSend') }}
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:[`item.folio`]="{ item }">
          <div>
            {{ item.folio }}
          </div>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          <div>
            {{ $moment(item.date).format('DD/MM/YYYY') }}
          </div>
        </template>
        <!-- <template v-slot:[`item.beneficiary`]="{ item }">
          <div>
            {{ item.beneficiary }}
          </div>
        </template> -->
        <template v-slot:[`item.concept`]="{ item }">
          <div>
            {{ item.concept ? item.concept : '-' }}
          </div>
        </template>
        <template v-slot:[`item.charge`]="{ item }">
          <div class="text-right">
            {{ item.kind === 'outgoing' ? formatCurrency(item.amount) : '-' }}
          </div>
        </template>
        <template v-slot:[`item.deposit`]="{ item }">
          <div class="text-right">
            {{ item.kind === 'income' ? formatCurrency(item.amount) : '-' }}
          </div>
        </template>
        <template v-slot:[`item.balance`]="{ item }">
          <div class="text-right">
            {{ item.balance | toFix2 | numberWithComma | prefix('$') }}
          </div>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <div>
            {{ $t(`expenses.registerMovements.movements.drawerAdd.${item.type}`) }}
          </div>
        </template>
        <template v-slot:[`item.category`]="{ item }">
          <div>
            {{ item.incomeType ? item.incomeType.name : item.outgoingCategory ? item.outgoingCategory.name : '-' }}
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import moment from 'moment'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import AddBankMovement from '@/components/sidePanels/AddBankMovement'
import getLocale from '@/lang/locale'
import formatCurrency from '@/utils/formatCurrency'

export default {
  name: 'Movements',
  components: {
    AddBankMovement
  },
  mixins: [validationMixin],
  validations: {
    bankForm: {
      bank: { required }
    }
  },
  data () {
    return {
      overlay: false,
      section: this.$i18n.t('expenses.registerMovements.section'),
      movementsTable: {
        title: this.$i18n.t('expenses.registerMovements.movements.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('expenses.registerMovements.movements.headers.id'), value: 'folio', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.movements.headers.date'), value: 'date', sortable: false, align: 'center' },
          // { text: this.$i18n.t('expenses.registerMovements.movements.headers.beneficiary'), value: 'beneficiary', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.movements.headers.description'), value: 'concept', sortable: false, align: 'center' },
          { text: this.$i18n.t('expenses.registerMovements.movements.headers.charge'), value: 'charge', sortable: false, align: 'center' },
          { text: this.$i18n.t('expenses.registerMovements.movements.headers.deposit'), value: 'deposit', sortable: false, align: 'center' },
          { text: this.$i18n.t('expenses.registerMovements.movements.headers.balance'), value: 'balance', sortable: false, align: 'center' },
          { text: this.$i18n.t('expenses.registerMovements.movements.headers.type'), value: 'type', sortable: false, align: 'center' },
          { text: this.$i18n.t('expenses.registerMovements.movements.headers.category'), value: 'category', sortable: false, align: 'center' }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 30,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [],
          sortDesc: []
        },
        selected: []
      },
      search: '',
      isAddBankMovementPanelOpen: false,
      banks: {
        loading: false,
        data: []
      },
      bankForm: {
        valid: false,
        disabled: false,
        isEditing: false,
        bank: null
      },
      selectedMovementsDates: [],
      dateModalMovements: false
    }
  },
  async mounted () {
    await this.loadBanks()
    this.setDefaultMovementsDates()
  },
  computed: {
    dateRangeTextMovements () {
      return this.selectedMovementsDates.join(' ~ ')
    },
    locale () {
      return getLocale(this.$i18n.locale)
    },
    bankErrors () {
      const errors = []
      if (!this.$v.bankForm.bank.$dirty) return errors
      !this.$v.bankForm.bank.required && errors.push(this.$i18n.t('expenses.registerMovements.movements.bankErrorsReq'))
      return errors
    },
    movementsPermissions () {
      return this.$store.state.login.permissions['expenses'].components['financial-movements'].actions
    }
  },
  watch: {
    // 'search': async function (val) {
    //   const params = {}
    //   if (val.length >= 3) {
    //     try {
    //       params.q = `/${val}/i`
    //       await this.load(params)
    //     } catch (error) {
    //       this.$toasted.show(error.message, { duration: 3000 })
    //     }
    //   } else {
    //     this.load(params)
    //   }
    // },
    '$store.state.currentRestaurant.data': async function (val) {
      this.resetForm()
      await this.loadBanks()
      this.setDefaultMovementsDates()
    }
  },
  methods: {
    resetForm () {
      this.movementsTable.data = []
      this.movementsTable.total = 0
      this.isAddBankMovementPanelOpen = false
      this.banks.loading = false
      this.banks.data = []
      this.bankForm.valid = false
      this.bankForm.disabled = false
      this.bankForm.isEditing = false
      this.bankForm.bank = null
      this.selectedMovementsDates = []
      this.dateModalMovements = false
    },
    async loadBanks (params = null) {
      params = params || {
        restaurant: this.$store.state.currentRestaurant.data._id
      }

      this.banks.loading = true
      try {
        const response = await this.$api.get(`/v1/financial/balance-accounts`, params)
        this.banks.data = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.banks.loading = false
    },
    async loadBankMovements (params = null) {
      const [startDate, endDate] = this.selectedMovementsDates
      // Todo: add date variables
      params = {
        limit: this.movementsTable.options.itemsPerPage,
        skip: (this.movementsTable.options.itemsPerPage * (this.movementsTable.page - 1)),
        startDate,
        endDate,
        ...params
      }
      this.movementsTable.loading = true
      try {
        const response = await this.$api.get(`/v1/transfers`, params)
        this.movementsTable.data = response.data
        this.movementsTable.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.movementsTable.loading = false
    },
    openCreateMovementPanel () {
      this.isAddBankMovementPanelOpen = true
    },
    allowedMovementsDates (val) {
      const nowDate = new Date()
      const evalDate = new Date(moment(val).format('YYYY-MM-DDTHH:mm:ss.SSS'))

      return evalDate.getTime() <= nowDate.getTime()
    },
    orderDateRangeMovements () {
      this.selectedMovementsDates.sort((a, b) => new Date(a) - new Date(b))
    },
    addMovement () {
      this.$v.bankForm.$touch()

      if (!this.$v.bankForm.$invalid) {
        this.openCreateMovementPanel()
      }
    },
    getBankAccountText: item => item.name + ' - ' + item.account.name,
    confirmMovementsDates () {
      this.$refs.dialogMovementsDates.save(this.selectedMovementsDates)
      this.selectedMovementsDates.length === 2 && this.bankForm.bank && this.loadBankMovements({ bank: this.bankForm.bank })
    },
    setDefaultMovementsDates () {
      const nowDate = new Date()
      const bottomDate = new Date()
      bottomDate.setDate(nowDate.getDate() - 30)

      this.selectedMovementsDates = [this.$moment(bottomDate).format('YYYY-MM-DD'), this.$moment(nowDate).format('YYYY-MM-DD')]
    },
    formatCurrency,
    async updateMovementsTable (options) {
      const [startDate, endDate] = this.selectedMovementsDates
      if (this.bankForm.bank) {
        await this.loadBankMovements({
          limit: options.itemsPerPage,
          skip: (options.itemsPerPage * (options.page - 1)),
          startDate,
          endDate,
          bank: this.bankForm.bank
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .link:hover {
    text-decoration: underline;
    color: #3366BB !important;
  }

  .calendarTextField {
    height: 34px;
    width: 240px;
    border-radius: 22px;

    & ::v-deep .v-label {
      top: auto;
    }
  }

  .dateButton {
    text-transform: none;
  }
</style>
